import React, { useState } from "react";
import CustomModalContainer from "../../../../components/modals/CustomModalContainer";
import Button from "../../../ui/Button";
import OTPInput from "../../../ui/OTPInput";

interface StepThreeProps {
  open: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const StepThree: React.FC<StepThreeProps> = ({ open, onClose, onSuccess }) => {
  const [error, setError] = useState<string | null>(null);

  const handleOTPComplete = (enteredOtp: string) => {
    console.log("Submitting OTP: ", enteredOtp);

    // Mock login logic - Replace with actual API call
    if (enteredOtp === "123456") {
      setError(null);
      console.log("OTP verified successfully!");
    } else {
      setError("Invalid OTP. Please try again.");
    }
  };

  if (!open) return null; // Do not render the component if it's not open

  return (
    <CustomModalContainer
      title="Reset Password"
      footer={
        <div className="flex justify-between relative bottom-0">
          <Button
            type="button"
            onClick={onClose}
            label="Cancel"
            customStyle={{
              width: "auto",
              minWidth: "150px",
              background: "none",
              color: "#000",
            }}
          />
          <Button
            label="Confirm code"
            type="submit"
            customStyle={{
              width: "auto",
              minWidth: "150px",
            }}
            onClick={onSuccess}
          />
        </div>
      }
      open={open}
      onClose={onClose}
    >
      {/* Modal Body */}
      <div className="p-6">
        <div className="text-md font-semibold text-gray-600">
          Enter OTP code
        </div>
        <form className="space-y-4 w-full md:w-[450px]">
          <OTPInput length={6} onComplete={handleOTPComplete} />
          {error && <p className="text-red-500 text-sm">{error}</p>}

          <p className="text-sm text-gray-500 mt-6 text-center w-[450px] flex gap-2">
            Didn't receive a code?{" "}
            <button
              type="button"
              className="text-accent hover:underline border-none bg-none cursor-pointer outline-none"
              onClick={() => console.log("Resend OTP clicked")}
            >
              Resend
            </button>
          </p>
        </form>
      </div>
    </CustomModalContainer>
  );
};

export default StepThree;
